import Button from "../../button";
import styles from "./hero.module.scss";

const stats = [
    { value: "~4", label: "Anos de experiência" },
    { value: "∞", label: "Xícaras de café" },
];

export const Hero = () => {
    return (
        <section id="topo" className={styles["container"]}>
            <div className={styles["inner"]}>
                <div className={styles["content"]}>
                    <span className={styles["status"]}>
                        <i className={styles["dot"]} />
                        Disponível para novos projetos
                    </span>

                    <h1 className={styles["title"]}>
                        Matheus Batista
                        <span className={styles["title-line"]}>
                            Desenvolvedor <em>Frontend</em>
                        </span>
                    </h1>

                    <p className={styles["description"]}>
                        Construo interfaces rápidas, acessíveis e bem estruturadas.
                        Foco em React, TypeScript e design systems que escalam junto
                        com o produto.
                    </p>

                    <div className={styles["actions"]}>
                        <Button href="#projetos">Ver projetos</Button>
                        <Button href="#contato" variant="secondary">
                            Entrar em contato
                        </Button>
                    </div>

                    <ul className={styles["stats"]}>
                        {stats.map((stat) => (
                            <li key={stat.label} className={styles["stat"]}>
                                <strong>{stat.value}</strong>
                                <span>{stat.label}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className={styles["visual"]}>
                    <div className={styles["window"]}>
                        <div className={styles["window-bar"]}>
                            <span className={styles["window-dots"]}>
                                <i />
                                <i />
                                <i />
                            </span>
                            <span className={styles["window-file"]}>developer.ts</span>
                        </div>
                        <pre className={styles["code"]}>
                            <code>
                                <span className={styles["row"]}>
                                    <span className={styles["kw"]}>const</span>{" "}
                                    <span className={styles["var"]}>matheus</span>
                                    <span className={styles["op"]}>:</span>{" "}
                                    <span className={styles["type"]}>Developer</span>{" "}
                                    <span className={styles["op"]}>=</span>{" "}
                                    <span className={styles["op"]}>{"{"}</span>
                                </span>
                                <span className={styles["row"]}>
                                    {"  "}
                                    <span className={styles["prop"]}>stack</span>
                                    <span className={styles["op"]}>:</span>{" "}
                                    <span className={styles["op"]}>[</span>
                                    <span className={styles["str"]}>"react"</span>
                                    <span className={styles["op"]}>,</span>{" "}
                                    <span className={styles["str"]}>"typescript"</span>
                                    <span className={styles["op"]}>,</span>{" "}
                                    <span className={styles["str"]}>"angular"</span>
                                    <span className={styles["op"]}>],</span>
                                </span>
                                <span className={styles["row"]}>
                                    {"  "}
                                    <span className={styles["prop"]}>graduacao</span>
                                    <span className={styles["op"]}>:</span>{" "}
                                    <span className={styles["str"]}>
                                        "Eng. de Computação — IFCE"
                                    </span>
                                    <span className={styles["op"]}>,</span>
                                </span>
                                <span className={styles["row"]}>
                                    {"  "}
                                    <span className={styles["prop"]}>local</span>
                                    <span className={styles["op"]}>:</span>{" "}
                                    <span className={styles["str"]}>"Fortaleza, CE"</span>
                                    <span className={styles["op"]}>,</span>
                                </span>
                                <span className={styles["row"]}>
                                    {"  "}
                                    <span className={styles["prop"]}>focado</span>
                                    <span className={styles["op"]}>:</span>{" "}
                                    <span className={styles["bool"]}>true</span>
                                    <span className={styles["op"]}>,</span>
                                </span>
                                <span className={styles["row"]}>
                                    <span className={styles["op"]}>{"}"}</span>
                                    <span className={styles["caret"]} />
                                </span>
                            </code>
                        </pre>
                    </div>
                    <div className={styles["glow"]} />
                </div>
            </div>

            <a href="#sobre" className={styles["scroll"]}>
                <span>Role para explorar</span>
                <i />
            </a>
        </section>
    );
};

export default Hero;
